<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN">PART ONE</p>
<p class="pt"><span class="ePub-B">UNSPEAKABLE TRUTH</span></p>
<p class="PEP">Nature is mindless, but it has mastered the art of deception.</p>
<div class="PEPC-sp">
<p class="PEPC"><span class="ePub-B">—Ethan Iverson, </span><span class="ePub-I">The Fisherman and the Spider</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?a9074642